// @flow
import { createAction } from 'redux-actions';
import { reset as resetForm } from 'redux-form';
import type { Dispatch } from 'redux';
import type { $AxiosError } from 'axios';
import { EVENTS } from '../../../../../../../../browser/shared/constant/TicketConstant';
import { format } from '../../../../../../../../browser/shared/util/gigwalkApiErrorUtil';
import { createEvent as createTicketEvent } from '../../../../../../../redux/entities/tickets';
import * as snackbar from '../../../../../../../ducks/snackbar';
import types from './types';

export const submitSuccess = createAction(types.SUBMIT_SUCCESS);
export const submitError = createAction(types.SUBMIT_ERROR);
export const submit = createAction(
    types.SUBMIT,
    (values: Object, props: Object): Function => (
        (dispatch: Dispatch<any>): Promise<void> => {
            const { comment } = values;
            const { match } = props;
            const ticketId = parseInt(match.params.ticketId, 10);
            const params = {
                ticket_id: ticketId,
                ticket_event_type: EVENTS.COMMENT,
                ticket_event_data: { comment },
            };

            return dispatch(createTicketEvent(params))
                .then(() => {
                    dispatch(resetForm('addComment'));
                    dispatch(submitSuccess());
                })
                .catch((err: $AxiosError<Object>) => {
                    dispatch(submitError(err));
                    const resp = err ? err.response : null;
                    if (resp && resp.data && resp.data.gw_api_response) {
                        const message = format(resp.data.gw_api_response);
                        dispatch(snackbar.actions.enqueue(message, { variant: 'error' }));
                    }
                    return Promise.reject();
                });
        }
    )
);

export default {
    submit,
    submitError,
    submitSuccess,
};
